import { createSelector } from 'reselect';

export const invoicesContainer = ({ invoices }) => invoices;

export const invoicesSelector = createSelector(
  [invoicesContainer],
  ( invoices ) => ({ invoices }),
);
